import { FaLayerGroup, FaMoneyBill, FaUsers, FaWallet } from 'react-icons/fa6';
import { IoPeopleSharp } from 'react-icons/io5';
import { AppModule } from 'shared/types/appModule';

const modules: Array<AppModule> = [
  {
    name: 'Customers',
    icon: FaUsers,
    path: '/',
    matchs: [{ path: '/', exact: true }, { path: '/customer' }],
  },
  {
    name: 'Financeiro',
    icon: FaMoneyBill,
    path: '/financeiro',
    matchs: [{ path: '/financeiro' }],
  },
  {
    name: 'Cashbacks',
    icon: FaWallet,
    path: '/cashbacks',
    matchs: [{ path: '/cashbacks' }],
  },
  {
    name: 'Grupos de lojas',
    icon: FaLayerGroup,
    path: '/store-groups',
    matchs: [{ path: '/store-groups' }],
  },
  {
    name: 'Revendedor',
    icon: IoPeopleSharp,
    path: '/revendedor',
    matchs: [{ path: '/revendedor' }],
  },
];

export default modules;
